<ng-container *ngIf="this.Mode === 'design'">
    <ng-container *ngIf="(this.FormTemplateId == null) || (this.FormTemplateId == 0)">
        <p>Select a form template from the properties drawer.</p>
    </ng-container>

    <ng-container *ngIf="(this.FormTemplateId != null) && (this.FormTemplateId != 0)">
        <ng-container *ngIf="!FieldsInitialized">
            <p>Loading...</p>
        </ng-container>

        <ng-container *ngIf="FieldsInitialized">
            <div class="label-div">
                <mat-label class="field-label">{{this.DisplayName}}</mat-label>
            </div>
            <span *ngIf="ShowNoColumnsWarning" class="warning">No fields are selected. In the Properties for this grid, click Configure Form Grid to add fields.</span>

            <!-- DESIGN/FORM BUILDER MODE -->
            <kendo-grid #grid="remoteBindingDirectiveRef"
                        formTemplateInstancesGridRemoteBinding
                        [inputs]="this.DirectiveInputs"
                        [pageSize]="this.PageSize"
                        [skip]="this.Skip"
                        [sort]="this.Sort"
                        scrollable="virtual"
                        [rowHeight]="this.rowHeight"
                        [height]="this.GetGridHeight()"
                        [selectable]="true"
                        [sortable]="this.SortSettings"
                        [filterable]="this.GridIsFilterable"
                        [navigable]="true">

                <kendo-grid-column *ngIf="SubscriptionIdColumnDef"
                                   [width]="40"
                                   title=""
                                   [filterable]="false"
                                   [sortable]="true">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button class="command-btn" kendoButton kendoGridFocusable (click)="toggleSubscription(dataItem)">
                            <mat-icon class="row-action-icon {{subscribedIconClass(dataItem)}}"
                                      title="{{subscribedIconTitle(dataItem)}}">{{subscribedIcon(dataItem)}}</mat-icon>
                        </button>
                    </ng-template>
                </kendo-grid-column>

                <!--Add column definition to link form instances-->
                <kendo-grid-column *ngIf="IsLinkedFormInstanceColumnDef"
                                   [width]="57"
                                   field="{{IsLinkedFormInstanceColumnDef.name}}"
                                   title=""
                                   filter="boolean"
                                   [filterable]="true"
                                   [sortable]="false">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <mat-icon class="row-action-icon"
                                  svgIcon="{{linkFormInstanceIcon(dataItem)}}"
                                  (click)="toggleLinkFormInstance(dataItem)" title="Link this Form Instance">
                        </mat-icon>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column *ngIf="IsFavoriteColumnDef"
                                   [width]="57"
                                   field="{{IsFavoriteColumnDef.name}}"
                                   title=""
                                   filter="boolean"
                                   [filterable]="true"
                                   [sortable]="false">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <mat-icon class="row-action-icon" (click)="toggleFavorite(dataItem)" title="Favorite this Form Instance">{{favIcon(dataItem)}}</mat-icon>
                    </ng-template>
                </kendo-grid-column>

                <ng-container *ngFor="let columnDef of this.ColumnDefs; let iColIndex=index">
                    <kendo-grid-column field="{{columnDef.name}}"
                                       title="{{columnDef.alias || columnDef.displayName || columnDef.name}}"
                                       filter="{{this.getFilterType(columnDef)}}"
                                       [width]="this.getColumnWidth(columnDef)"
                                       [filterable]="this.ColumnIsFilterable(columnDef)">
                    </kendo-grid-column>
                </ng-container>
            </kendo-grid>
        </ng-container>
    </ng-container>
</ng-container>

<ng-container *ngIf="(this.Mode === 'preview') || (this.Mode === 'instance')">
    <ng-container *ngIf="(this.FormTemplateId == null) || (this.FormTemplateId == 0)">
        <p>This widget is not yet configured.</p>
    </ng-container>

    <ng-container *ngIf="(this.FormTemplateId != null) && (this.FormTemplateId != 0)">
        <ng-container *ngIf="ShowLoading">
            <p>Loading...</p>
        </ng-container>

        <ng-container *ngIf="FieldsInitialized">
            <div style="height: 628px;">
                <div class="label-div">
                    <mat-label class="field-label">{{this.DisplayName}}</mat-label>
                </div>
                <span *ngIf="ShowNoColumnsWarning" class="warning">No fields are selected. In the Properties for this grid, click Configure Form Grid to add fields.</span>

                <!-- PREVIEW/FORM INSTANCE MODE !!!! -->
                <div *ngIf="Message" style="font-size:12pt;padding:30px 30px 30px 0;">{{Message}}</div>
                <kendo-grid *ngIf="!Message"
                            formTemplateInstancesGridRemoteBinding
                            (notifyLoaded)="handleLoaded($event)"
                            (dataStateChange)="dataStateChange($event)"
                            [pageSize]="this.PageSize"
                            [skip]="this.Skip"
                            [sort]="this.Sort"
                            [height]="this.GetGridHeight()"
                            [selectable]="{ checkboxOnly: true }"
                            [kendoGridSelectBy]="selectedCallback"
                            [(selectedKeys)]="SelectedRows"
                            [sortable]="this.SortSettings"
                            [filterable]="this.GridIsFilterable"
                            (filterChange)="handleFilterChange($event)"
                            [navigable]="true"
                            (cellClick)="this.onCellClick($event)"
                            [rowClass]="Helper.applyClickedRowClassToClickedRow"
                            [(filter)]="Helper.Filters"
                            [groupable]="this.EnableGridGrouping"
                            (groupChange)="this.groupChange($event)"
                            [rowReorderable]="this.UserCanReorderForms"
                            (rowReorder)="this.handleRowReorder($event)"
                            style="height: 600px; min-height: 600px;">

                    <ng-template kendoGridToolbarTemplate>

                        <div *ngIf="GridIsFilterable">
                            <button *ngIf="!ShowGridFilter" class="{{ActionButtonClass}}"
                                    mat-raised-button color="primary" (click)="this.turnOnGridFilter()">
                                <span aria-label="Click to enable filter" title="Click to enable filter">Show Filters</span>
                            </button>

                            <button *ngIf="ShowGridFilter" class="{{ActionButtonClass}}"
                                    mat-raised-button color="primary" (click)="this.turnOffGridFilter()">
                                <span aria-label="Click to disable filter" title="Click to disable filter">Remove Filters</span>
                            </button>
                        </div>

                        <button *ngIf="CanCreateForm && showActionButton('createform')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('createform')">
                            {{buttonName('createform')}}
                        </button>
                        <button *ngIf="CanCreateFolder && showActionButton('createfolder')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('createfolder')">
                            {{buttonName('createfolder')}}
                        </button>
                        <button *ngIf="CanDeleteForm && showActionButton('delete')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('delete')">
                            {{buttonName('delete')}}
                        </button>
                        <button *ngIf="CanMoveForm && showActionButton('move')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('move')">
                            {{buttonName('move')}}
                        </button>
                        <button *ngIf="CanCopyForm && showActionButton('copy')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('copy')">
                            {{buttonName('copy')}}
                        </button>
                        <button *ngIf="showActionButton('publishform')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('publishform')">
                            {{buttonName('publishform')}}
                        </button>
                        <button *ngIf="showActionButton('publishfolder')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('publishfolder')">
                            {{buttonName('publishfolder')}}
                        </button>
                        <button *ngIf="showActionButton('exportData')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('exportData')">
                            {{buttonName('exportData')}}
                        </button>
                        <button *ngIf="showActionButton('bulkWorkflow')" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('bulkWorkflow')">
                            {{buttonName('bulkWorkflow')}}
                        </button>

                        <!--VNEXT-810
                            <button *ngIf="true" class="{{ActionButtonClass}}" mat-raised-button color="primary"
                                (click)="handleSelectActionClick('subscribeAll')">
                            {{buttonName('subscribeAll')}}
                        </button>-->

                        <button *ngIf="SelectedRows.length > 0 && GridMode == 'manage'" class="perform-action-button" mat-raised-button color="accent"
                                (click)='handlePerformActionClick()'>
                            Continue
                        </button>
                        <button *ngIf="showCancelButton()" mat-raised-button class="cancel-action"
                                (click)='handleCancelActionClick()'>
                            Cancel Action
                        </button>

                        <div *ngIf="ShowInstructions">
                            Select the Forms you wish to perform this action on
                        </div>
                        <ng-container *ngIf="Helper.IsBeingFiltered">
                            <button class="clear-all-filters-btn" mat-stroked-button (click)='Helper.handleClearFilters()'>Clear Filters</button>
                            <span class="x-of-n">{{Helper.ShowingXofN}}</span>
                        </ng-container>

                        <kendo-grid-spacer></kendo-grid-spacer>
                    </ng-template>

                    <ng-container *ngIf="!this.HasGrouping">
                        <kendo-grid-rowreorder-column autosize="false" [width]=12></kendo-grid-rowreorder-column>

                        <kendo-grid-column *ngIf="ShowCheckboxes" [width]=12>
                            <ng-template kendoGridHeaderTemplate>
                                <kendo-checkbox kendoGridSelectAllCheckbox
                                                [state]="selectAllState"
                                                (selectAllChange)="onSelectAllChange($event)" />
                            </ng-template>

                            <ng-template kendoGridCellTemplate let-dataItem let-idx="rowIndex">
                                <kendo-checkbox *ngIf="!isDisabled(dataItem, idx)"
                                                [kendoGridSelectionCheckbox]="idx"
                                                [id]="idx"></kendo-checkbox>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-command-column *ngIf="CommandColumnPostion=='left'" [width]=18 class="!k-text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <button kendoButton kendoGridFocusable (click)="openFormInstance(dataItem)" title="Open Form">Open</button>
                            </ng-template>
                        </kendo-grid-command-column>

                        <kendo-grid-column *ngIf="SubscriptionIdColumnDef"
                                           [width]="20"
                                           title=""
                                           [filterable]="false"
                                           [sortable]="true">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <mat-icon class="row-action-icon {{subscribedIconClass(dataItem)}}"
                                          (click)="toggleSubscription(dataItem)"
                                          title="{{subscribedIconTitle(dataItem)}}">{{subscribedIcon(dataItem)}}</mat-icon>
                            </ng-template>
                        </kendo-grid-column>

                        <!--Add column definition to link form instances-->
                        <kendo-grid-column *ngIf="IsLinkedFormInstanceColumnDef"
                                           [width]="20"
                                           field="{{IsLinkedFormInstanceColumnDef.displayName}}"
                                           title="LinkedFormInstance"
                                           filter="boolean"
                                           [filterable]="this.ShowGridFilter"
                                           [sortable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <mat-icon class="row-action-icon"
                                          svgIcon="{{linkFormInstanceIcon(dataItem)}}"
                                          (click)="toggleLinkFormInstance(dataItem)"
                                          title="{{linkFormInstanceTitle(dataItem)}}">
                                </mat-icon>
                            </ng-template>
                            <ng-template kendoGridHeaderTemplate>
                                <span title="LinkFormInstance" class="column-header">🔗</span>
                            </ng-template>
                            <!--<kendo-grid-messages filterIsTrue="🔗" filterIsFalse="🔗"></kendo-grid-messages>-->
                        </kendo-grid-column>

                        <kendo-grid-column *ngIf="IsFavoriteColumnDef"
                                           [width]="20"
                                           field="{{IsFavoriteColumnDef.displayName}}"
                                           title="Favorite"
                                           filter="boolean"
                                           [filterable]="this.ShowGridFilter"
                                           [sortable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <mat-icon class="row-action-icon"
                                          (click)="toggleFavorite(dataItem)"
                                          title="{{favIconTitle(dataItem)}}">
                                    {{favIcon(dataItem)}}
                                </mat-icon>
                            </ng-template>
                            <ng-template kendoGridHeaderTemplate>
                                <span title="Favorite" class="column-header">★</span>
                            </ng-template>
                            <kendo-grid-messages filterIsTrue="Yes" filterIsFalse="No"></kendo-grid-messages>
                        </kendo-grid-column>

                        <ng-container *ngFor="let columnDef of this.ColumnDefs; let iColIndex=index">
                            <kendo-grid-column field="{{columnDef.displayName || columnDef.name}}"
                                               title="{{columnDef.alias || columnDef.displayName || columnDef.name}}"
                                               filter="{{this.getFilterType(columnDef)}}"
                                               format="{{this.getFormat(columnDef)}}"
                                               [width]="this.getColumnWidth(columnDef)"
                                               [filterable]="this.ColumnIsFilterable(columnDef)"
                                               [sortable]="true">

                                <!-- Added to enable use of title attribute for hover text -->
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    <span title="{{column.title}}" class="column-header">{{column.title}}</span>
                                </ng-template>

                                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                    <!-- show value  -->
                                    <span *ngIf="!FormRenameInProgress || columnDef.name != 'name' || RowIndexClicked != rowIndex"
                                          [innerHTML]="this.getCellDisplayValue(dataItem, columnDef, iColIndex)"></span>

                                    <!-- textbox for editing name -->
                                    <span *ngIf="FormRenameInProgress && columnDef.name === 'name' && RowIndexClicked == rowIndex">
                                        <input matInput #formNameInput
                                               class="form-name-input"
                                               value="{{dataItem.Name}}"
                                               (keydown)="renameFormKeydown($event)"
                                               maxlength="256" type="text"
                                               id="{{dataItem.Id}}">
                                    </span>

                                    <!-- pencil icon to initiate name edit -->
                                    <span *ngIf="UserClickedOnNameColumn && !FormRenameInProgress && columnDef.name === 'name' && RowIndexClicked == rowIndex"
                                          title="Rename form" (click)="renameFormClick(columnDef)">
                                        <mat-icon class="material-icons rename-icon">edit</mat-icon>
                                    </span>
                                    <!-- save edited name -->
                                    <span *ngIf="FormRenameInProgress && columnDef.name === 'name' && RowIndexClicked == rowIndex"
                                          title="Save name" (click)="renameFormSave()">
                                        <mat-icon class="material-icons save-rename-icon">check_circle</mat-icon>
                                    </span>
                                    <!-- cancel name edit -->
                                    <span *ngIf="FormRenameInProgress && columnDef.name === 'name' && RowIndexClicked == rowIndex"
                                          title="Cancel rename form" (click)="renameFormCancel()">
                                        <mat-icon class="material-icons cancel-rename-icon">cancel</mat-icon>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>

                        <kendo-grid-command-column *ngIf="CommandColumnPostion=='right'" [width]=18 class="!k-text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <button kendoButton kendoGridFocusable (click)="openFormInstance(dataItem)" title="Open Form">Open</button>
                            </ng-template>
                        </kendo-grid-command-column>
                    </ng-container>

                    <ng-container *ngIf="this.HasGrouping">

                        <kendo-grid-command-column *ngIf="this.HasGrouping && CommandColumnPostion=='left'" [width]=50 class="!k-text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <button kendoButton kendoGridFocusable (click)="openGroupedFormInstance(dataItem)" title="Open Form">Open</button>
                            </ng-template>
                        </kendo-grid-command-column>

                        <ng-container *ngFor="let fieldName of this.FieldDisplayNames">
                            <kendo-grid-column field="{{fieldName}}">
                                <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                                    <!--Group Count: {{ aggregates.Count.sum }}-->
                                    <ng-container *ngFor="let aggregateInfo of this.Aggregates; let i=index">
                                        <ng-container *ngIf="i > 0">
                                            <br />
                                        </ng-container>
                                        <span>
                                            {{this.getAggregateTitle(aggregateInfo)}}: {{this.getAggregateValue(aggregates, aggregateInfo)}}
                                        </span>
                                    </ng-container>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                    </ng-container>

                    <kendo-grid-command-column *ngIf="this.HasGrouping && CommandColumnPostion=='right'" [width]=50 class="!k-text-center">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <button kendoButton kendoGridFocusable (click)="openGroupedFormInstance(dataItem)" title="Open Form">Open</button>
                        </ng-template>
                    </kendo-grid-command-column>

                </kendo-grid>

                <!-- Context menu. -->
                <kendo-contextmenu #gridmenu
                                   [kendoMenuHierarchyBinding]="this.MenuItems"
                                   [textField]="['text', 'childText']"
                                   childrenField="children"
                                   svgIconField="svgIcon"
                                   separatorField="separator"
                                   (select)="this.onContextMenuSelect($event)"></kendo-contextmenu>
            </div>
        </ng-container>
    </ng-container>

</ng-container>
